import { useBahasa } from '../../app/i18n'
import { DI_DEV, LINGKUNGAN } from '../lib/lingkungan'

/**
 * Baris merek di rel navigasi: nama produk, nama antarmuka, dan lingkungan.
 *
 * BENTUKNYA MENGIKUTI MOCKUP yang disepakati 7 September — `Smova` tebal, nama
 * antarmuka di bawahnya, chip lingkungan di sebelahnya. Versi pertama fase B
 * mengarang nama sendiri ("Konsol Operator") padahal `DESAIN_BACKOFFICE.md` sudah
 * menetapkan ketiganya dan menyebutnya "sekaligus jadi kosakata peran, supaya tidak
 * ada dua kosakata untuk satu hal". Mengarang nama baru persis melanggar itu.
 *
 * Chip lingkungan HANYA muncul di dev. Di produksi ia tidak berguna — semua orang di
 * sana memang di produksi — dan chip yang selalu ada berhenti dibaca.
 */
export default function Merek({ antarmuka }) {
  const { t } = useBahasa()
  return (
    <div className="px-[18px] flex flex-col gap-0.5">
      <div className="flex items-center gap-1.5">
        <b className="text-[15px] font-bold tracking-[-.01em]">{t('app.nama')}</b>
        {DI_DEV && (
          <span
            title={t('login.lingkungan')}
            className="text-[9.5px] font-semibold uppercase tracking-[.06em]
                       text-warn border border-line rounded px-1 py-px"
          >
            {LINGKUNGAN}
          </span>
        )}
      </div>
      <span className="text-[11px] text-ink3">{antarmuka}</span>
    </div>
  )
}
